/**
 * @generated SignedSource<<5b7ccb3ba30690fdf8e131aead8148b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ConditionalFormattingSidebarExperience$data = {
  readonly id: string;
  readonly " $fragmentType": "main_issueNavigator_ConditionalFormattingSidebarExperience";
};
export type main_issueNavigator_ConditionalFormattingSidebarExperience$key = {
  readonly " $data"?: main_issueNavigator_ConditionalFormattingSidebarExperience$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ConditionalFormattingSidebarExperience">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_ConditionalFormattingSidebarExperience",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "3ea0c99d55d188dfcf550df88b4fa039";

export default node;
